// src/utils/colorPalette.ts

export interface ColorInfo {
  name: string;
  hex: string;
  group: string;
}

const createColor = (name: string, hex: string, group: string): ColorInfo => ({
  name,
  hex,
  group,
});

export const frenchColorPalette: ColorInfo[] = [
  // Rouges
  createColor('Rouge', '#FF0000', 'Reds'),
  createColor('Rouge Foncé', '#8B0000', 'Reds'),
  createColor('Carmin', '#DC143C', 'Reds'),
  createColor('Brique', '#B22222', 'Reds'),
  createColor('Saumon', '#FA8072', 'Reds'),
  createColor('Tomate', '#FF6347', 'Reds'),
  createColor('Corail', '#FF7F50', 'Reds'),

  // Roses
  createColor('Rose', '#FFC0CB', 'Pinks'),
  createColor('Rose Vif', '#FF69B4', 'Pinks'),
  createColor('Rose Profond', '#FF1493', 'Pinks'),

  // Oranges
  createColor('Orange', '#FFA500', 'Oranges'),
  createColor('Orange Foncé', '#FF8C00', 'Oranges'),
  createColor('Orange Rouge', '#FF4500', 'Oranges'),

  // Jaunes
  createColor('Jaune', '#FFFF00', 'Yellows'),
  createColor('Or', '#FFD700', 'Yellows'),
  createColor('Kaki', '#F0E68C', 'Yellows'),
  createColor('Pêche', '#FFDAB9', 'Yellows'),

  // Verts
  createColor('Vert', '#008000', 'Greens'),
  createColor('Vert Foncé', '#006400', 'Greens'),
  createColor('Vert Clair', '#90EE90', 'Greens'),
  createColor('Citron Vert', '#00FF00', 'Greens'),
  createColor('Vert Marin', '#2E8B57', 'Greens'),
  createColor('Vert Forêt', '#228B22', 'Greens'),
  createColor('Olive', '#808000', 'Greens'),

  // Cyans
  createColor('Cyan', '#00FFFF', 'Cyans'),
  createColor('Turquoise', '#40E0D0', 'Cyans'),
  createColor('Sarcelle', '#008080', 'Cyans'),

  // Bleus
  createColor('Bleu', '#0000FF', 'Blues'),
  createColor('Bleu Foncé', '#00008B', 'Blues'),
  createColor('Bleu Marine', '#000080', 'Blues'),
  createColor('Bleu Roi', '#4169E1', 'Blues'),
  createColor('Bleu Ciel', '#87CEEB', 'Blues'),
  createColor('Bleu Acier', '#4682B4', 'Blues'),
  createColor('Bleuet', '#6495ED', 'Blues'),

  // Violets
  createColor('Violet', '#8A2BE2', 'Purples'),
  createColor('Indigo', '#4B0082', 'Purples'),
  createColor('Magenta', '#FF00FF', 'Purples'),
  createColor('Orchidée', '#DA70D6', 'Purples'),
  createColor('Prune', '#DDA0DD', 'Purples'),

  // Bruns
  createColor('Brun', '#A52A2A', 'Browns'),
  createColor('Terre de Sienne', '#A0522D', 'Browns'),
  createColor('Chocolat', '#D2691E', 'Browns'),
  createColor('Ocre', '#D2B48C', 'Browns'),

  // Blancs & Gris
  createColor('Blanc', '#FFFFFF', 'Whites & Grays'),
  createColor('Neige', '#FFFAFA', 'Whites & Grays'),
  createColor('Ivoire', '#FFFFF0', 'Whites & Grays'),
  createColor('Gris', '#808080', 'Whites & Grays'),
  createColor('Noir', '#000000', 'Whites & Grays'),
  createColor('Argent', '#C0C0C0', 'Whites & Grays'),
];
